import KunLoading50 from './src/index'

KunLoading50.install = function (Vue) {
	Vue.component(KunLoading50.name, KunLoading50);
}

export default KunLoading50;
